import Configs from "../config";
import { CreateLinkIRoute, UpdateLinkIRoute } from "../generated/Api";
import { ILink } from "../types/LinkTypes";
import { DefaultResponse } from "../types/UtilTypes";
import { localStorageGetItem } from "../utils/LocalStorage";

const create = async (body: Omit<CreateLinkIRoute, "userUid">) => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/link`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ ...body, userUid }),
  });

  const link: DefaultResponse<ILink> = await response.json();
  if (link.status === "ok") {
    return link.data as ILink;
  }

  throw new Error(link.code);
};

// const update = async (body: UpdateLinkIRoute): Promise<UpdateLinkIRoute> => {
//   const token = localStorageGetItem("USER_TOKEN");
//   const response = await fetch(`${Configs.SERVER_URL}/link/${body._id}`, {
//     method: "PUT",
//     headers: {
//       Accept: "application/json",
//       "Content-type": "application/json",
//       Authorization: "Bearer " + token,
//     },
//     body: JSON.stringify(body),
//   });

//   const link: DefaultResponse<UpdateLinkIRoute> = await response.json();
//   if (link.status === "ok") {
//     return link.data as UpdateLinkIRoute;
//   }

//   throw new Error(link.code);
// };

const readAll = async () => {
  const userUid = localStorageGetItem("USER_UID");
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/link/userUid/${userUid}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );

  const links: DefaultResponse<ILink[]> = await response.json();
  if (links.status === "ok") {
    return links.data as ILink[];
  }

  throw new Error(links.code);
};

const remove = async (linkId: string): Promise<ILink> => {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/link/${linkId}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  const link: DefaultResponse<ILink> = await response.json();
  if (link.status === "ok") {
    return link.data as ILink;
  }

  throw new Error(link.code);
};

export const LinksAPI = {
  create,
  // update,
  readAll,
  remove,
};
